/*
 * TODO: construct universal transmitter/receiver that replaces hardcoded …
 * TODO: "document.getElementsByTagName("rm-loading-dots")[0].setAttribute("action","off");" …
 * TODO: in html doc (e.g. in reminder.html)
 */
import './assets/rm-loading-dots.css';
import template from './rm-loading-dots-template';

class RmLoadingDots extends HTMLElement {
    constructor() {
        super();
        this.action = '';
        this.curIndex = 0;
    }

    loadAnimation = function loadAnimation(that) {
        that = that || this;
        const loadImages = this.querySelectorAll('.loadingDots');
        loadImages.forEach((el) => {
            el.style.display = 'none';
        });
        loadImages[that.curIndex].style.display = '';
        that.curIndex = that.curIndex !== 2 ? that.curIndex + 1 : 0;
        that.loadAnimationInProgress = setTimeout(function () {
            that.loadAnimation(that);
        }, 600);
    };

    start() {
        this.style.display = 'block';
        this.loadAnimation(this);
    }

    stop = function _stop() {
        setTimeout(() => {
            clearTimeout(this.loadAnimationInProgress);
            this.style.display = 'none';
        }, 350);
    };

    static get observedAttributes() {
        return ['action'];
    }

    attributeChangedCallback(property, oldValue, newValue) {
        if (oldValue === newValue) return;
        const that = this;
        that[property] = newValue;
        if (this.action === 'off') {
            this.stop();
        }
    }

    // connect component
    connectedCallback() {
        document.addEventListener('bk-error', () => {
            this.stop();
        });

        this.append(template.content.cloneNode(true));

        this.loadAnimation();

        document.addEventListener('bk-start-loading', () => {
            this.start();
        });
        document.addEventListener('bk-stop-loading', () => {
            this.stop();
        });
    }
}

export default RmLoadingDots;
